import React, {Component} from 'react';
import {connect} from 'react-redux';
import {authSelectors} from "../../store/auth";
import {calendarActions, calendarSelectors} from "../../store/calendar";
import {layoutActions} from "../../store/layout";

import {Box} from 'rebass'
import Calendar from '../../pages/Calendar'
import {GlobalStyle} from "../../theme";
import {withFirebase} from "../../components/Firebase";
import { withRouter } from "react-router";

/* Container for My Posts page */

class CalendarContainer extends Component {

	state = {
		toth: null,
		tothData: []
	}

	async componentDidMount() {
		const {dateString, updateHeaderProps} = this.props;
		this.listener = this.fetchTothListener(dateString)
		updateHeaderProps({noSideBar: true, bg: '#263039'});


		/* -- */
		const tothRef = await this.props.firebase.toth().get();
		const tothData = await tothRef.docs.map(doc => {
			const id = doc.id;
			const data = doc.data();
			return { id, ...data }
		});
		
		this.setState({
			tothData: tothData
		});
	}

	fetchToth = async (date) => {
		try {
			let tothRef = await this.props.firebase.toth(date).get()
			const result = {
				id: tothRef.id,
				...tothRef.data()
			}
			this.setState({toth: result})
		} catch (error) {
			console.log("Failed to fetch TOTH: ", error)
		}
	}

	fetchTothListener = (date) => {
		return this.props.firebase.categories().orderBy('created_at', 'asc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
			// updateCategories(result)
			this.fetchCategorySchedule(result)
			this.fetchManageCategorySchedule(result, date)

		})
	}

	// fetches subcategories and schedules as one
	fetchCategorySchedule = async (categories) => {
		const { dateString, updateToth} = this.props;
		let newToth = {
			date: dateString,
			schedule: categories.map(category => ({id: category.id, category: category.name, details: []}))
		}
		try {
			for(let i in categories){
				let scheduleRef = await this.props.firebase.calendarSchedule(categories[i].id, dateString).get()
				let schedule = {...scheduleRef.data()}
				// let schedule = scheduleRef.ref.data()
				for(let j in schedule.schedule){
					let subcategoryRef = await this.props.firebase.calendarSubcategory(categories[i].id, schedule.schedule[j]).get()
					newToth.schedule[i].details.push({id: subcategoryRef.id, ...subcategoryRef.data()})
				}
			}

			for(let i = newToth.schedule.length - 1; i >=0; i--){
				if(newToth.schedule[i].details.length === 0){
					newToth.schedule.splice(i, 1);
				}
			}
			// console.log(newToth)
			updateToth(newToth)
			// this.setState({toth: newToth})
		} catch (error) {
			console.log('Failed to fetch schedule', error)
		}
	}

	// fetches subcategories and schedules as one
	fetchManageCategorySchedule = async (categories, currentDate) => {
		// const {updating} = this.state;
		const {updateCategories} = this.props;

		try {
			for(let i in categories){
				let activatedScheduleRef = await this.props.firebase.calendarSchedule(categories[i].id, currentDate).get()
				if(!activatedScheduleRef.exists){
					activatedScheduleRef = await this.handleAddScheduleDate(categories[i].id)
				}
				const activatedSchedule = {id: activatedScheduleRef.id, ...activatedScheduleRef.data()}
				let scheduleRef = await this.props.firebase.calendarSubcategories(categories[i].id).get()

				let result = []
				scheduleRef.docs.forEach(doc => (result.push({id: doc.id, activated: activatedSchedule.schedule.includes(doc.id), ...doc.data()})) )
				categories[i].schedule = result
				categories[i].activated = activatedSchedule

			}
			updateCategories(categories)

		} catch (error) {
			console.log('Failed to fetch schedule', error)
		}
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if(nextProps.dateString !== this.props.dateString){
			this.listener = this.fetchTothListener(nextProps.dateString)
		}
	}

	componentWillUnmount() {
		this.listener()
	}

	render() {
		const {toth} = this.props;
		let schedule = []
		if(toth !== null){
			schedule = toth.schedule
		}
		return (
			<div>
				<GlobalStyle/>
				<Box p={[0, 0]} ml={[0, 0]} mt={[10, 0]} pt={30} mb={[50, 0]}>
					<Calendar
						{...this.props}
						tothData={this.state.tothData}
						tothSchedule={schedule}
					/>
				</Box>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		loadingProfile: authSelectors.isLoading(state.auth),
		categories: calendarSelectors.refreshCategories(state.calendar),
		loadingCategories: calendarSelectors.isLoading(state.calendar),
		date: calendarSelectors.refreshDate(state.calendar),
		dateString: calendarSelectors.refreshDateString(state.calendar),
		toth: calendarSelectors.refreshCurrentToth(state.calendar),
		selectedDate: calendarSelectors.refreshSelectedDate(state.calendar)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		updateDate: (data) => dispatch(calendarActions.updateDate(data)),
		updateToth: (data) => dispatch(calendarActions.updateToth(data)),
		updateCategories: (data) => dispatch(calendarActions.updateCategories(data)),
		updateHeaderProps: (data) => dispatch(layoutActions.updateHeaderProps(data)),
		updateSelectedDate: (date) => dispatch(calendarActions.updateSelectedDate(date))
	}
}
export default withFirebase(connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(CalendarContainer)))
